import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { KeyRound, Loader2, Mail } from "lucide-react";

export const AdminDialogs = ({
  pwUser, setPwUser, newPw, setNewPw, busy, onSetPassword, onSendReset,
  delUser, setDelUser, onDeleteUser,
}) => (
  <>
    {/* Password dialog */}
    <Dialog open={!!pwUser} onOpenChange={(o) => !o && setPwUser(null)}>
      <DialogContent className="bg-white rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-heading">Reset password</DialogTitle>
          <DialogDescription>{pwUser?.email}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Set a new password directly</Label>
            <Input data-testid="admin-new-password" type="text" value={newPw} onChange={(e) => setNewPw(e.target.value)} className="mt-1.5 border-line" placeholder="At least 6 characters" />
            <button data-testid="admin-set-password-btn" disabled={busy || newPw.length < 6} onClick={onSetPassword} className="mt-2 w-full bg-forest text-white py-2.5 rounded-lg font-medium hover:bg-forest-hover flex items-center justify-center gap-2 disabled:opacity-60"><KeyRound className="h-4 w-4" /> Set password</button>
          </div>
          <div className="relative text-center"><span className="text-xs text-mute bg-white px-2 relative z-10">or</span><div className="absolute inset-x-0 top-1/2 border-t border-line" /></div>
          <button data-testid="admin-send-reset-btn" disabled={busy} onClick={onSendReset} className="w-full border border-forest text-forest py-2.5 rounded-lg font-medium hover:bg-forest/5 flex items-center justify-center gap-2 disabled:opacity-60"><Mail className="h-4 w-4" /> Email a reset link instead</button>
        </div>
      </DialogContent>
    </Dialog>

    {/* Delete dialog */}
    <Dialog open={!!delUser} onOpenChange={(o) => !o && setDelUser(null)}>
      <DialogContent className="bg-white rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-heading text-red-600">Delete user?</DialogTitle>
          <DialogDescription>
            This permanently deletes <span className="font-medium text-ink">{delUser?.email}</span>
            {delUser?.role === "landlord" ? " and cascades to all their properties, leases, applications, showings and maintenance." : " and all their applications, leases and messages."} This cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <button onClick={() => setDelUser(null)} className="px-4 py-2 rounded-lg border border-line hover:bg-bone text-sm">Cancel</button>
          <button data-testid="confirm-delete-user" disabled={busy} onClick={onDeleteUser} className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 text-sm flex items-center gap-2 disabled:opacity-60">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Delete permanently</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </>
);
